var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchLupa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.971,
    height: 15.971,
    viewBox: "0 0 15.971 15.971",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "search-lupa",
    d: "M7.557,13.045h.721l.256-.247a5.945,5.945,0,1,1,.639.639l-.247.256v.721L4.361,18.971,3,17.611Zm5.479,0A4.109,4.109,0,1,0,8.926,8.936,4.1,4.1,0,0,0,13.036,13.045Z",
    transform: "translate(-3 -3)",
    fill: "#2d2d2d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchLupa);
export default __webpack_public_path__ + "static/media/search-lupa.905e5bb82dadb0a15bf710f79150ae88.svg";
export { ForwardRef as ReactComponent };